export default class ConfigConnection {
  // Prod API
  apiInstance = 'https://api-psicoassess.com:3001/';
  // apiInstance = "http://localhost:3000/";
  apiKey = "LBNwrsKT2pJEgSV428zob3q3gSkjYQYnpxpD00GNChu5msbkur5w9dqHPtEh6klr";
  // Dev API
  // apiInstance = "http://35.171.109.238:8081/";
}
